// Libraries
import { sliderAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(sliderAnatomy.keys);

/**
 * Base style configuration for the Popover component.
 */
const baseStyle = definePartsStyle({
  track: {
    bg: '#DBDFF1',
    h: 1.5,
  },
  thumb: {
    opacity: 0.9,
    boxSize: 4,
    bg: 'navbar',
    borderColor: 'white',
    filter: 'drop-shadow(0px 4px 3px rgba(54, 36, 226, 0.12)) drop-shadow(0px 9px 7px rgba(0, 0, 0, 0.10))',
  },
  mark: {
    bg: 'transparent',
    top: 3,
  },
  container: {
    h: 8,
    cursor: 'grab',
    _active: {
      cursor: 'grabbing',
    },
  },
});

/**
 * Chakra UI Popover theme configuration.
 */
export const Slider = defineMultiStyleConfig({ baseStyle });
